import { render, staticRenderFns } from "./RepaymentDetail.vue?vue&type=template&id=1b0efa5e&scoped=true&"
import script from "./RepaymentDetail.vue?vue&type=script&lang=js&"
export * from "./RepaymentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0efa5e",
  null
  
)

export default component.exports